<template>
  <v-app
    id="inspire"
    :style="{ background: $vuetify.theme.themes[theme].background }"
  >
    <v-navigation-drawer
      app
      v-model="drawer"
      disable-route-watcher
      temporary
      clipped
      fixed
    >
      <sidebar-menu
        :nav="menu"
        v-on:closeDrawer="drawer = false"
      ></sidebar-menu>
    </v-navigation-drawer>

    <v-app-bar app
               :extended="!!($store.state.extensionEnable && $store.state.extensionMenu.length)"
               elevation="0"
               :clipped-left="clipped"
               color="grey"
               :extension-height="70"
    >
      <template v-slot:img="{ props }">
        <v-img
          v-bind="props"
          gradient="to top, rgba(0,0,0), rgba(26, 26, 26)"
        ></v-img>
      </template>
      <v-app-bar-nav-icon v-if="$store.getters.isAuth" class="onPrimary--text" @click="drawer = !drawer" />
      <slot name="toolbar-left"></slot>
      <v-spacer></v-spacer>
      <slot name="toolbar-right"></slot>

      <template
        v-if="$store.getters.extensionEnable && $store.getters.extensionMenu.length"
        v-slot:extension
      >
      <extended-btn-menu></extended-btn-menu>

      </template>
    </v-app-bar>

    <v-main>
      <slot></slot>
    </v-main>

    <the-footer v-if="!['OrderBarExpressPage','OrderFlowPage','OrderManagerPage','OrderFlowKitchenPage','OrderFlowOvenPage'].includes($route.name)"></the-footer>
  </v-app>
</template>

<script>
import SidebarMenu from "./SidebarMenu";
import TheFooter from "./TheFooter";
import ExtendedBtnMenu from "@/layout/components/ExtendedBtnMenu/ExtendedBtnMenu";

export default {
  components: {ExtendedBtnMenu, SidebarMenu, TheFooter },
  props: {
    menu: { type: Array, default: null },
  },
  data: () => ({
    drawer: false,
    clipped: true,
  }),
  computed: {
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },
};
</script>
